import { ConnectedPosition } from '@angular/cdk/overlay';
import { AsyncPipe } from '@angular/common';
import { Component, inject, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { OiqUiBadge } from '@oiq-ui-sdk/ui';
import { OiqUiDropdownComponent } from '@oiq-ui/dropdown.component';
import { ToastrService } from 'ngx-toastr';
import { combineLatest, map } from 'rxjs';
import { OiqNotificationEventsComponent } from '../events/events.component';
import { OiqNotificationEventsStore } from '../events/events.store';
import { OiqSmsAlertsStore } from '../sms-alerts/sms-alerts.store';

@Component({
  selector: 'oiq-notification-button',
  styleUrls: ['./notification-button.component.scss'],
  encapsulation: ViewEncapsulation.None,
  templateUrl: './notification-button.component.html',
  imports: [OiqNotificationEventsComponent, OiqUiDropdownComponent, OiqUiBadge, AsyncPipe],
})
export class OiqNotificationButtonComponent implements OnInit, OnDestroy {
  @ViewChild('dropdownRef')
  dropdownRef: OiqUiDropdownComponent;

  private toastr = inject(ToastrService);
  public eventsStore = inject(OiqNotificationEventsStore);
  private smsAlertsStore = inject(OiqSmsAlertsStore);
  public upcomingEventsCount$ = this.eventsStore.updates$.pipe(
    map(_total => _total['upcoming-events'] || 0)
  );
  public badgeCount$ = combineLatest([
    this.upcomingEventsCount$,
    this.smsAlertsStore.unreadCount$.pipe(map(_unread => _unread.count || 0)),
  ]).pipe(map(([_upcoming, _sms]) => _upcoming + _sms));
  public overlayPositions: ConnectedPosition[] = [
    {
      originX: 'end',
      originY: 'bottom',
      overlayX: 'center',
      overlayY: 'top',
    },
  ];
  constructor() {
    // KEEP!!!
    // this.hasUpcomingEvents$.subscribe(r => {
    //   if (!r) {
    //     return;
    //   }
    //   this.openNotifications();
    // });

    this.eventsStore.updatesUpcomingEvents$.subscribe(r => {
      r.forEach(row => this._openToastr(row));
    });
  }

  ngOnInit(): void {
    this.eventsStore.intervalEnabled$.next(true);
  }
  ngOnDestroy(): void {
    this.eventsStore.intervalEnabled$.next(false);
  }

  handleNotification(event$: { type: string; data: any }) {
    switch (event$.type) {
      case 'close':
        this.closeNotifications();
        break;

      default:
        break;
    }
  }

  openNotifications() {
    this.dropdownRef.open();
  }

  closeNotifications() {
    this.dropdownRef.close();
  }

  toggleNotifications() {
    this.dropdownRef.toggle();
  }

  private _openToastr(calendarEvent) {
    let message = `<span data-id="${calendarEvent.id}">${calendarEvent.title}</span>`;
    let action =
      calendarEvent.entityName && calendarEvent.entityId && calendarEvent.entityType
        ? calendarEvent.entityType
        : 'Calendar';

    const activeToast = this.toastr.show(message, action, {
      disableTimeOut: true,
      enableHtml: true,
      tapToDismiss: false,
      closeButton: true,
      toastClass: 'toast-calendar toast show border',
    });

    if (activeToast && activeToast.toastRef) {
      activeToast.toastId = calendarEvent.id;
      activeToast.toastRef.componentInstance.calendarEvent = calendarEvent; // use the component instance to send the input parameters
      activeToast.toastRef.componentInstance.showEntityLink = true; // use the component instance to send the input parameters
    }
  }
}
